import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

const initialState = {
    language:{ id:1, name:'ไทย', brev:'th', image:'🇹🇭'},
    modal_Language:false,
    backtoHome:false

}


export const deviceSlice = createSlice({
  name: 'device',
  initialState,
  reducers: {
    updateBackToHome: (state,action) => {
      state.backtoHome = action.payload
    },
    updateLanguage: (state,action) => {
      state.language = action.payload
    },

  },
  extraReducers: builder => {
   
  }
})

export const { updateLanguage, updateBackToHome
} = deviceSlice.actions

export default deviceSlice.reducer